/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Infinite_ScrollInputs */

const en_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infinite scroll`)
};

const ar_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التمرير اللانهائي`)
};

const bn_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনফিনিট স্ক্রল`)
};

const de_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unendliches Scrollen`)
};

const es_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento infinito`)
};

const fr_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défilement infini`)
};

const pt_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolagem infinita`)
};

const zh_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限滚动`)
};

const tr_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonsuz kaydırma`)
};

const ru_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесконечная прокрутка`)
};

const pl_svchip_infinite_scroll = /** @type {(inputs: Svchip_Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieskończone przewijanie`)
};

/**
* | output |
* | --- |
* | "Infinite scroll" |
*
* @param {Svchip_Infinite_ScrollInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_infinite_scroll = /** @type {((inputs?: Svchip_Infinite_ScrollInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Infinite_ScrollInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_infinite_scroll(inputs)
	if (locale === "bn") return bn_svchip_infinite_scroll(inputs)
	if (locale === "de") return de_svchip_infinite_scroll(inputs)
	if (locale === "es") return es_svchip_infinite_scroll(inputs)
	if (locale === "fr") return fr_svchip_infinite_scroll(inputs)
	if (locale === "pt") return pt_svchip_infinite_scroll(inputs)
	if (locale === "zh") return zh_svchip_infinite_scroll(inputs)
	if (locale === "tr") return tr_svchip_infinite_scroll(inputs)
	if (locale === "ru") return ru_svchip_infinite_scroll(inputs)
	if (locale === "pl") return pl_svchip_infinite_scroll(inputs)
	return en_svchip_infinite_scroll(inputs)
});